import * as React from "react";

function SvgGd6DLogoMiniBlanc(props) {
  return (
    <svg
      id="GD6D__logo-mini--blanc_svg__Calque_1"
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 266.26 140.11"
      {...props}
    >
      <defs>
        <style>
          {
            ".GD6D__logo-mini--blanc_svg__cls-1{fill:#fff}.GD6D__logo-mini--blanc_svg__cls-2{fill:#cfd8dc}"
          }
        </style>
      </defs>
      <path
        className="GD6D__logo-mini--blanc_svg__cls-1"
        d="M144.3 67.72v1.74a16.9 16.9 0 01-5.47 13.12 18.24 18.24 0 01-12.17 4.67 17.22 17.22 0 11-.1-34.44 17.73 17.73 0 0114 6.56l-6.11 4.72a9.15 9.15 0 00-7.6-3.83c-5.32 0-9.34 4.23-9.34 9.89a9.66 9.66 0 009.69 9.79 8.66 8.66 0 008.3-5.71h-8.15v-6.51zM148.68 53.46h9.69c5.71 0 9.24 1 12.27 3.62a16.1 16.1 0 015.42 12.63 17.68 17.68 0 01-5.27 13.07c-2.73 2.48-6.76 3.82-11.53 3.82h-10.58zm8 26.53H158c5.87 0 9.94-4.07 9.94-10a10.8 10.8 0 00-3-7.65 10.31 10.31 0 00-6.61-2.38h-1.54zM191.12 66.48a5.17 5.17 0 011.09-.15c4.88 0 8.85 4.42 8.85 9.74a11.15 11.15 0 01-11.18 11.23 10.36 10.36 0 01-10.58-10.64c0-3.33 1.24-6.61 4.17-11.23l7.65-12h8.45zm-4.77 10a3.6 3.6 0 003.73 3.73 3.85 3.85 0 003.92-3.8 3.69 3.69 0 00-3.72-3.87 3.88 3.88 0 00-3.93 3.97zM205.74 53.46h9.69c5.71 0 9.24 1 12.27 3.62a16.1 16.1 0 015.42 12.63 17.68 17.68 0 01-5.27 13.07c-2.73 2.48-6.76 3.82-11.53 3.82h-10.58zm8 26.53H215c5.86 0 9.94-4.07 9.94-10a10.84 10.84 0 00-3-7.65 10.35 10.35 0 00-6.61-2.38h-1.55z"
      />
      <circle
        className="GD6D__logo-mini--blanc_svg__cls-1"
        cx={66.09}
        cy={84.81}
        r={7.38}
      />
      <circle
        className="GD6D__logo-mini--blanc_svg__cls-1"
        cx={66.09}
        cy={55.29}
        r={7.38}
      />
      <circle
        className="GD6D__logo-mini--blanc_svg__cls-1"
        cx={66.09}
        cy={84.81}
        r={7.38}
      />
      <circle
        className="GD6D__logo-mini--blanc_svg__cls-1"
        cx={40.53}
        cy={70.05}
        r={7.38}
      />
      <circle
        className="GD6D__logo-mini--blanc_svg__cls-1"
        cx={66.09}
        cy={55.29}
        r={7.38}
      />
      <circle
        className="GD6D__logo-mini--blanc_svg__cls-1"
        cx={40.53}
        cy={70.05}
        r={7.38}
      />
      <path
        className="GD6D__logo-mini--blanc_svg__cls-2"
        d="M44.22 34.13a7.38 7.38 0 00-11.07 6.4v2.54a15.33 15.33 0 0026.55 0l-15.48-8.93M33.15 99.58A7.38 7.38 0 0044.22 106l2.2-1.27a15.32 15.32 0 00-13.27-23v17.85M95.35 76.44a7.39 7.39 0 000-12.79l-2.2-1.27a15.33 15.33 0 00-13.27 23l15.47-8.93"
      />
      <path
        className="GD6D__logo-mini--blanc_svg__cls-1"
        d="M33.15 40.53a7.38 7.38 0 0111.07-6.4l2.2 1.27a15.33 15.33 0 01-13.27 23V40.53M44.22 106a7.38 7.38 0 01-11.07-6.39V97a15.32 15.32 0 0126.54 0l-15.47 9M95.35 63.65a7.39 7.39 0 010 12.79l-2.2 1.27a15.32 15.32 0 01-13.27-23l15.47 8.93"
      />
    </svg>
  );
}

export default SvgGd6DLogoMiniBlanc;
